export enum CompanyRunOutcome {
  COMPLETED = "completed",
  ASSESSED = "assessed",
  EXCEPTION = "exception",
  DEFERRED = "deferred",
}

export const dataByCompanyRunOutcome: Record<
  CompanyRunOutcome,
  { label: string }
> = {
  [CompanyRunOutcome.COMPLETED]: { label: "Completed" },
  [CompanyRunOutcome.ASSESSED]: { label: "Assessed" },
  [CompanyRunOutcome.EXCEPTION]: { label: "Exception" },
  [CompanyRunOutcome.DEFERRED]: { label: "Deferred" },
}
